module.exports = __webpack_public_path__ + "img/ocost.3bda607e.png";